__turbopack_context__.v({
  "ellipsisText": "TooltipText-module__cnEIpa__ellipsisText",
});
